import { v4 } from 'uuid'

import { FormItemDraggableBase } from './form-item-draggable-base'
import { IconEnum } from '../../../../../assets/icons'
import { FormItemType } from '../../constants/form-builder.constants'

export const ListDraggable = () => {
  const id = v4()
  const type = FormItemType.Select

  return (
    <FormItemDraggableBase
      icon={IconEnum.CheckRounded}
      id={id}
      title="formBuilder.list"
      type={type}
    />
  )
}
